import request from './request'
import * as http from '@/libs/http'

/**
 * ログイン認証を行う
 *
 * @param {String} orgcode 組織コード
 * @param {Object} data ログイン情報
 * @returns {Response} レスポンスデータ
 */
export function auth (orgcode, data) {
  return request.post(`/org/${orgcode}/auth`, {
    id: data.email,
    password: data.password
  }, {
    validateStatus: (status) => [
      http.OK,
      http.Unauthorized,
      http.Forbidden
    ].includes(status)
  })
}
